import DevicesOverviewIcon from "./DevicesOverviewIcon";
import KnowledgeBaseIcon from "./KnowledgeBaseIcon";
import LogsIcon from "./LogsIcon";
import MapMarkerIcon from "./MapMarkerIcon";
import QRCodeIcon from "./QRCodeIcon";
import SpacesOverviewIcon from "./SpacesOverviewIcon";
import OverviewIcon from "./SummaryIcon";

export {
    DevicesOverviewIcon,
    KnowledgeBaseIcon,
    LogsIcon,
    MapMarkerIcon,
    OverviewIcon,
    QRCodeIcon,
    SpacesOverviewIcon,
};
